import httpClient from '../utils/http'
import moment from 'moment'
import _ from 'lodash'
import { handleResponseAsync } from '../utils/HelperUtils'
import Chance from 'chance'
import { normalize } from 'normalizr'
import { viewConstants } from '../_constants/view.constants'
import { eventSchema } from '../entities/schema'
import { toast } from 'react-toastify'
import { post } from 'jquery'

toast.configure()

export const rosterService = {
           getAllETime,
           queryRoster,
           fetchETime,
           fetchEmployeeETime,
           updateEvent,
           updateOne,
           updatePreviewEvent,
           deletePreviewEvent,
           addEvent,
           addEventMulti,
           removeEventById,
           removeRosters,
           copyInsertEvents,
           submit,
           undoApproval,
       }

function convertViewModelList(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            const m = {}
            m.id = o.RosterAutoID || o.PayrollEmpRosterAutoID
            m.Title = o.RosterDispTitle || o.PayrollEmpRosterDispTitle || generateTitle(o)
            m.Note = o.RosterNotes || o.PayrollEmpRosterActionNotes
            m.Break = o.RosterBreakMinute !== undefined ? o.RosterBreakMinute : (o.PayrollEmpRosterBreakMinute || 0)
            m.EmployeeID = o.RosterEmployeeID || o.PayrollEmpRosterEmployeeID
            m.EmployeeName = o.EmployeeName
            m.ActionType = o.RosterActionTypeID !== undefined ? o.RosterActionTypeID : (o.PayrollEmpRosterActionTypeID || 0)
            m.CompanyId = o.RosterCompanyID || o.PayrollEmpRosterCompanyID
            m.hours = o.RosterHours || o.PayrollEmpRosterHours
            m.source = o.source
            m.Employee = o.Employee
            
            // Determine approval status
            const isApproved = o.RosterApproved !== undefined ? o.RosterApproved : (o.PayrollEmpRosterStatus === 'approved' || o.Status === 'approved')
            m.Status = isApproved ? 'approved' : 'draft'
            m.draggable = !isApproved

            // Use startTime/endTime if available, otherwise reconstruct from date + time parts
            if (o.startTime) {
                m.start = moment(o.startTime).toDate()
            } else if (o.RosterDate && o.RosterStartTimeHour !== undefined) {
                const start = moment(o.RosterDate)
                start.hour(o.RosterStartTimeHour)
                start.minute(o.RosterStartTimeMinute || 0)
                m.start = start.toDate()
            } else {
                m.start = moment(o.PayrollEmpRosterStartDate).toDate()
            }
            
            if (o.endTime) {
                m.end = moment(o.endTime).toDate()
            } else if (o.RosterEndDate && o.RosterFinishTimeHour !== undefined) {
                const end = moment(o.RosterEndDate)
                end.hour(o.RosterFinishTimeHour)
                end.minute(o.RosterFinishTimeMinute || 0)
                m.end = end.toDate()
            } else {
                m.end = moment(o.PayrollEmpRosterEndDate).toDate()
            }

            if (m.ActionType < 99) {
                m.allDay = true
            }
            viewModel.push(m)
        })
    }
    const eventListSchema = [eventSchema]
    const normalizedData = normalize(viewModel, eventListSchema)
    return normalizedData.entities
}

function addIdField(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            o.id = o.RosterAutoID || o.PayrollEmpRosterAutoID
            viewModel.push(o)
        })
    }
    return viewModel
}

function convertViewModel(data) {
    const m = {}
    if (!_.isEmpty(data)) {
        m.id = data.RosterAutoID || data.PayrollEmpRosterAutoID
        m.Title = data.RosterDispTitle || data.PayrollEmpRosterDispTitle || generateTitle(data)
        m.Note = data.RosterNotes || data.PayrollEmpRosterActionNotes
        m.Break = data.RosterBreakMinute !== undefined ? data.RosterBreakMinute : (data.PayrollEmpRosterBreakMinute || 0)
        m.EmployeeID = data.RosterEmployeeID || data.PayrollEmpRosterEmployeeID
        m.EmployeeName = data.EmployeeName
        m.ActionType = data.RosterActionTypeID !== undefined ? data.RosterActionTypeID : (data.PayrollEmpRosterActionTypeID || 0)
        m.CompanyId = data.RosterCompanyID || data.PayrollEmpRosterCompanyID
        m.hours = data.RosterHours || data.PayrollEmpRosterHours
        m.source = data.source
        m.Employee = data.Employee
        
        // Determine approval status
        const isApproved = data.RosterApproved !== undefined ? data.RosterApproved : (data.PayrollEmpRosterStatus === 'approved' || data.Status === 'approved')
        m.Status = isApproved ? 'approved' : 'draft'
        m.draggable = !isApproved

        // Use startTime/endTime if available, otherwise reconstruct from date + time parts
        if (data.startTime) {
            m.start = moment(data.startTime).toDate()
        } else if (data.RosterDate && data.RosterStartTimeHour !== undefined) {
            const start = moment(data.RosterDate)
            start.hour(data.RosterStartTimeHour)
            start.minute(data.RosterStartTimeMinute || 0)
            m.start = start.toDate()
        } else {
            m.start = moment(data.PayrollEmpRosterStartDate).toDate()
        }
        
        if (data.endTime) {
            m.end = moment(data.endTime).toDate()
        } else if (data.RosterEndDate && data.RosterFinishTimeHour !== undefined) {
            const end = moment(data.RosterEndDate)
            end.hour(data.RosterFinishTimeHour)
            end.minute(data.RosterFinishTimeMinute || 0)
            m.end = end.toDate()
        } else {
            m.end = moment(data.PayrollEmpRosterEndDate).toDate()
        }
    }
    const normalizedData = normalize(m, eventSchema)
    return normalizedData.entities
}

function convertById(data) {
    return data.PayrollEmpRosterAutoID
}

function castToModelNew(data, updateMode) {
    const vm = {}

    vm.PayrollEmpRosterActionNotes = data.Note || ''
    vm.PayrollEmpRosterDispTitle = data.Title || ''
    vm.PayrollEmpRosterStartDate = data.StartDate || data.start
    vm.PayrollEmpRosterEndDate = data.EndDate || data.end
    vm.PayrollEmpRosterActionTypeID = data.ActionType
    vm.PayrollEmpRosterBreakMinute = _.toNumber(data.Break) || 0
    vm.PayrollEmpRosterStatus = data.Status || 0
    vm.PayrollEmpRosterEmployeeID = data.EmployeeID
    vm.PayrollEmpRosterHours = data.Hours

    if (updateMode) {
        vm.dateFrom = data.dateFrom
        vm.dateTo = data.dateTo
    }

    return vm
}

function castToModelMultiEmp(data, updateMode) {
    const vm = {}

    if (undefined !== data.id) {
        vm.PayrollEmpRosterAutoID = data.id
    }

    vm.PayrollEmpRosterActionNotes = data.Note || ''
    vm.PayrollEmpRosterDispTitle = data.Title || ''
    vm.PayrollEmpRosterStartDate = data.StartDate || data.start
    vm.PayrollEmpRosterEndDate = data.EndDate || data.end
    vm.PayrollEmpRosterActionTypeID = data.ActionType
    vm.PayrollEmpRosterBreakMinute = _.toNumber(data.Break) || 0
    vm.PayrollEmpRosterStatus = data.Status || 0
    vm.PayrollEmpRosterEmployeeID = data.employeeID
    vm.PayrollEmpRosterHours = data.Hours
    vm.employees = data.employees

    if (updateMode) {
        vm.dateFrom = data.dateFrom
        vm.dateTo = data.dateTo
    }

    return vm
}

function getAllETime() {
    const url = '/api/etime/preview'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function queryRoster(options) {
    const url = '/api/etime/preview'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign({}, defaultQueryCond, options);

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertToRosterFormat(res.data))
}

// Helper: construct ISO datetime from date and hour/minute components
function constructDateTime(date, hour, minute) {
    if (!date && hour === undefined) return null
    const m = moment(date)
    if (hour !== undefined) m.hour(hour)
    if (minute !== undefined) m.minute(minute)
    return m.toISOString()
}

// Convert preview API data to PayrollEmpRoster format used by roster management components
function convertToRosterFormat(data) {
    if (!_.isArray(data)) return data
    return data.map(o => {
        const r = {}
        // Map to PayrollEmpRoster field names
        r.PayrollEmpRosterAutoID = o.RosterAutoID
        r.PayrollEmpRosterEmployeeID = o.RosterEmployeeID
        r.PayrollEmpRosterCompanyID = o.RosterCompanyID
        r.EmployeeName = o.EmployeeName
        // Use full ISODateTime strings if available, else construct from date+time
        r.PayrollEmpRosterStartDate = o.startTime || (o.RosterDate ? constructDateTime(o.RosterDate, o.RosterStartTimeHour, o.RosterStartTimeMinute) : null)
        r.PayrollEmpRosterEndDate = o.endTime || (o.RosterEndDate ? constructDateTime(o.RosterEndDate, o.RosterFinishTimeHour, o.RosterFinishTimeMinute) : null)
        r.PayrollEmpRosterStartTimeHour = o.RosterStartTimeHour
        r.PayrollEmpRosterStartTimeMinute = o.RosterStartTimeMinute
        r.PayrollEmpRosterFinishTimeHour = o.RosterFinishTimeHour
        r.PayrollEmpRosterFinishTimeMinute = o.RosterFinishTimeMinute
        r.PayrollEmpRosterDispTitle = o.RosterDispTitle || generateTitle(o)
        r.PayrollEmpRosterActionNotes = o.RosterNotes
        r.PayrollEmpRosterBreakMinute = o.RosterBreakMinute || 0
        r.PayrollEmpRosterActionTypeID = o.RosterActionTypeID !== undefined ? o.RosterActionTypeID : 0
        r.PayrollEmpRosterStatus = o.RosterApproved !== undefined ? (o.RosterApproved ? 'approved' : 'draft') : 'draft'
        r.PayrollEmpRosterHours = o.RosterHours
        r.PayrollEmpRosterWorkPlanID = o.RosterWorkPlanID
        r.PayrollEmpRosterOriginalRosterID = o.RosterOriginalRosterID
        r.PayrollEmpRosterLocation1ID = o.RosterLocation1ID
        r.PayrollEmpRosterLocation2ID = o.RosterLocation2ID
        r.PayrollEmpRosterLocation3ID = o.RosterLocation3ID
        r.PayrollEmpRosterLocation4ID = o.RosterLocation4ID
        r.PayrollEmpRosterLocation5ID = o.RosterLocation5ID
        r.PayrollEmpRosterTaskID = o.RosterTaskID
        r.PayrollEmpRosterApproved = o.RosterApproved
        // Add id field for convenience
        r.id = o.RosterAutoID
        if (o.Employee) {
            r.Employee = o.Employee
        }
        return r
    })
}

// Generate a fallback title from time range if no title is provided
function generateTitle(o) {
    let title = '';
    if (o.startTime && o.endTime) {
        title = `${moment(o.startTime).format('HH:mm')} - ${moment(o.endTime).format('HH:mm')}`;
    } else if (o.RosterDate && o.RosterStartTimeHour !== undefined && o.RosterFinishTimeHour !== undefined) {
        const start = moment(o.RosterDate).hour(o.RosterStartTimeHour).minute(o.RosterStartTimeMinute || 0);
        const end = moment(o.RosterDate).hour(o.RosterFinishTimeHour).minute(o.RosterFinishTimeMinute || 0);
        title = `${start.format('HH:mm')} - ${end.format('HH:mm')}`;
    } else {
        title = 'Shift';
    }
    const employeeName = o.EmployeeName || '';
    return employeeName ? `${title} ${employeeName}` : title;
}

function fetchETime(options) {
    const url = '/api/etime/preview'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign({}, defaultQueryCond, options);
    // let queryCond = options || defaultQueryCond

    // const config = {
    //     url: _url,
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    //     method: 'post',
    //     data: queryCond,
    // }

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function fetchEmployeeETime(options) {
    const { employeeID } = options
    // const _url = `/api/etime/preview/${employeeID}`
    const url = `/api/etime/preview/1`

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign(options, defaultQueryCond)

    // const config = {
    //     url: _url,
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    //     method: 'post',
    //     data: queryCond,
    // }

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateEvent(evt) {
    const url = '/api/etime'
    const payload = castToModelMultiEmp(evt, true)

    return httpClient
        .put(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateOne(payload) {
    const url = '/api/etime/UpdateOne'

    return httpClient
        .put(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

/**
 * PUT /api/etime/preview
 * Updates a roster record using the preview payload format.
 * Payload mirrors the raw Roster* field shape returned by the preview API.
 */
function updatePreviewEvent(payload) {
    const url = '/api/etime/preview'

    return httpClient
        .put(url, payload)
        .then(handleResponseAsync)
        .then(res => res.data)
}

/**
 * DELETE /api/etime/preview
 * Deletes a roster record by RosterAutoID.
 * Body: { RosterAutoID: number }
 */
function deletePreviewEvent(rosterAutoID) {
    const url = '/api/etime/preview'

    return httpClient
        .delete(url, { data: { RosterAutoID: rosterAutoID } })
        .then(handleResponseAsync)
        .then(res => res.data)
}

function removeEventById(evtId) {
    const url = `/api/etime/${evtId}`

    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}

/**
 * bulk delete
 * @param {*} evtId 
 * @returns 
 */
function removeRosters(payload) {
    const url = `/api/etime/delete`

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}

function addEvent(payload) {
    const url = '/api/etime'
    // const payload = castToModelNew(evt)

    // delete payload.PayrollEmpRosterAutoID

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function addEventMulti(evt) {
    const url = '/api/etime/m'
    const payload = castToModelMultiEmp(evt)

    delete payload.PayrollEmpRosterAutoID

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function copyInsertEvents(data){
    const url = '/api/etime/copy'

    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function submit(recordIds){
    const url = '/api/etime/submit'

    return httpClient
        .post(url, recordIds)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

/**
 * 
 * @param {*} recordIds 
 * @returns 
 */
function undoApproval(recordIds){
    const url = '/api/etime/reject'

    return httpClient
        .post(url, recordIds)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}